import sendIcon from "../icons/send.svg";

export default function SendBoldIcon({ className }) {
  return (
    <img
      src={sendIcon}
      className={className}
      alt=""
      aria-hidden="true"
    />
  );
}